export default __webpack_public_path__ + "static/media/Success_button.png.223808fe.svg";